import React, { Component } from 'react';

import withAuthorization from './withAuthorization';
import { db } from '../firebase';
import {Navbar, Icon, Col,Card,CardTitle} from 'react-materialize'

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: null,
    };
  }

  componentDidMount() {
    db.onceGetUsers().then(snapshot =>
      this.setState(() => ({ users: snapshot.val() }))
    );
  }

  render() {
    const { users } = this.state;
    return (
      <div>
        <center>
          <h1>Home</h1>
          <p>The Home Page is accessible by every signed in user.</p>
        </center>
        <Col m={6} s={12}>
          <Card className='blue-grey darken-1' textClassName='white-text' title='Card title' actions={[<a href='#'>This is a link</a>]}>
            I am a very simple card.
          </Card>
        </Col>
        <Card className='small'
          header={<CardTitle image='http://hotspot.engelsoft.com.br/images/portal/mesh-wave.jpg'>Card Title</CardTitle>}
          actions={[<a href='#'>This is a Link</a>]}>
          I am a very simple card. I am good at containing small bits of information. I am convenient because I require little markup to use effectively.
        </Card>
        <Card header={<CardTitle reveal image={"http://hotspot.engelsoft.com.br/images/portal/mesh-wave.jpg"} waves='light'/>}
          title="Card Title"
          reveal={<p>Here is some more information about this product that is only revealed once clicked on.</p>}>
          <p><a href="#">This is a link</a></p>
        </Card>
        { !!users && <UserList users={users} /> }
      </div>
    );
  }
}

const UserList = ({ users }) =>
  <Card header={<CardTitle reveal image={"http://hotspot.engelsoft.com.br/images/portal/mesh-wave.jpg"} waves='light'/>}
    title="List of Usernames of Users"
    reveal={
      <div>
      <p>(Saved on Sign Up in Firebase Database)</p>
      {Object.keys(users).map(key =>
        <div key={key}>{users[key].username}</div>
      )}</div>}>
    <p>
      <a href="#">This is a link</a>
    </p>
  </Card>


const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(HomePage);



// WEBPACK FOOTER //
// ./src/components/Home.js